import type { ReactNode } from "react";

import classes from "./_css/index.module.css";

type Props = {
  children: ReactNode;
  grow?: boolean;
};

export function NavbarSection({ children, grow }: Props) {
  return (
    <div className={classes.section} data-grow={grow || undefined}>
      {children}
    </div>
  );
}
